export default __webpack_public_path__ + "static/media/PlantsForDinner_04.2ed91fee.png";